export enum Language {
  ru = 'ru',
  az = 'az'
}
